































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import FlexButton from '@/components/FlexButton/FlexButton.vue';
import ContextMenu from '@/components/ContextMenu/ContextMenu.vue';
import ContextMenuOption from '@/components/ContextMenu/ContextMenuOption';
import WarnApiTokenConnectionProviderTooltip from '@/components/WarningApiTokenConnectionProvider/WarnApiTokenConnectionProviderTooltip.vue';
import {
  EConnectionTypeProvider,
  IConnectOauth,
  IProvider
} from '@/models/provider';
import { EBusinessProviders } from '../BusinessTypeSelector/business-providers.enum';
import { isRemoteLoading } from '@/utils/remote-loading';

@Component({
  components: {
    ContextMenu,
    FlexButton,
    WarnApiTokenConnectionProviderTooltip
  }
})
export default class ProviderBox extends Vue {
  @Prop({ required: true }) data!: any;
  @Prop({ required: false, default: 'default' }) variant!:
    | 'default'
    | 'minimalistic';

  showWarningApiToken: boolean = false;

  get tPrefix() {
    return 'common.components.providerBox';
  }

  get type() {
    const strs: { [i: string]: string[] } = {
      physical_online: [
        String(this.$t(`${this.tPrefix}.types.labels.physical_online`)),
        String(this.$t(`${this.tPrefix}.types.limitations.stores`))
      ],
      physical: [
        String(this.$t(`${this.tPrefix}.types.labels.physical`)),
        String(this.$t(`${this.tPrefix}.types.limitations.only`))
      ],
      online: [
        String(this.$t(`${this.tPrefix}.types.labels.online`)),
        String(this.$t(`${this.tPrefix}.types.limitations.only`))
      ]
    };

    return strs[this.data.type] || [];
  }

  get isRemoteLoading() {
    return isRemoteLoading();
  }

  get prefixHost() {
    if (this.isRemoteLoading) return '/dashboard';

    return '';
  }

  get contextMenuOptions() {
    const options: ContextMenuOption[] = [];
    if (this.data.features.includes('widget')) {
      options.push(
        new ContextMenuOption(
          'widget',
          String(this.$t(`${this.tPrefix}.contextMenuOption.widget`))
        )
      );
    }

    if (this.providerPending) {
      options.push(
        new ContextMenuOption(
          'cancelIntegration',
          String(this.$t(`${this.tPrefix}.contextMenuOption.cancelIntegration`))
        )
      );
    }
    return options;
  }

  get providersToUpdate(): IConnectOauth[] {
    return this.$store.getters['merchant/getProvidersToUpdate'];
  }

  get rewardsProgram() {
    return this.$store.getters['business/getRewardStatus'] || {};
  }

  get providerPending() {
    if (!this.rewardsProgram.providers) return false;

    const providerSquare = this.rewardsProgram.providers.filter(
      (ele: any) => ele.provider === EBusinessProviders.SQUARE
    )[0];

    return (
      providerSquare &&
      this.data.name === EBusinessProviders.SQUARE &&
      this.data.connected &&
      this.rewardsProgram.operationStatus === 'active' &&
      providerSquare.rewardStatus === 'pending'
    );
  }

  handleContextMenuClick(action: string, id: string, props: any) {
    switch (action) {
      case 'widget':
        this.$router.push({
          path: `/loyalty-widget`
        });
        break;

      case 'cancelIntegration':
        this.onClick('disconnect');
        break;
    }
  }

  onClick(event: string) {
    this.$emit(event);
  }

  shouldDisplayWarningConnection(provider: any) {
    if (!this.shouldUpdateProvider(provider)) {
      return false;
    }

    return provider.authType === EConnectionTypeProvider.API_TOKEN;
  }

  shouldUpdateProvider(provider: IProvider) {
    return this.providersToUpdate.some(
      shouldUpdateProvider => shouldUpdateProvider.id === provider.oauthId
    );
  }
  openTooltipWarningApiToken() {
    this.showWarningApiToken = true;
  }

  getDisplayStatus(provider: IProvider): string {
    if (this.shouldDisplayWarningConnection(provider)) {
      return 'Action needed';
    }
    if (this.providerPending) {
      return 'Pending';
    }
    return this.$t(`${this.tPrefix}.status.connected.label`) as string;
  }

  getClassDisplayStatus(provider: IProvider): string {
    if (this.shouldDisplayWarningConnection(provider)) {
      return 'action-needed';
    }
    if (this.providerPending) {
      return 'pending';
    }
    return 'connected';
  }

  updatedConnection() {
    this.showWarningApiToken = false;
    setTimeout(() => {
      location.reload();
    }, 1000);
  }

  disconnectByWarningProvider() {
    this.showWarningApiToken = false;
    this.onClick('disconnect');
  }
}
